import routerOptions0 from "/builds/namicomi/frontend/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.29_db0@0.3.2_eslint@9.28.0_jiti@2.4_b53b74f15580d955d34ca2b221d1d6bb/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}